var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 34,
    viewBox: "0 0 26 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3863 24.3287C19.5798 23.7097 19.6841 23.0513 19.6841 22.3685C19.6841 19.2621 17.5255 16.66 14.6264 15.9802L14.3977 16.3764C13.6279 17.7097 11.7034 17.7097 10.9336 16.3764L8.06962 11.4158C7.29982 10.0825 8.26207 8.41584 9.80167 8.41584H15.5296C17.0692 8.41584 18.0314 10.0825 17.2616 11.4158L16.7532 12.2965C17.8442 13.7064 19.5528 14.6141 21.4735 14.6141C22.8015 14.6141 24.0282 14.1802 25.0194 13.4463C25.0414 13.1425 25.0526 12.8357 25.0526 12.5263C25.0526 5.60822 19.4444 0 12.5263 0C5.60822 0 0 5.60822 0 12.5263C0 14.6256 0.516391 16.6042 1.42907 18.3421H1.41991L1.45578 18.3927C1.96345 19.3487 2.59135 20.2312 3.31931 21.0199L12.5263 34L19.3863 24.3287Z",
    fill: "url(#paint0_radial_312_1570)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_312_1570",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.24561 -3.42982) rotate(84.9909) scale(37.5733 27.6856)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.126859,
    stopColor: "#3300FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.652948,
    stopColor: "#9755EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFB3"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c26fa17a0e4c138f8eb44055e4fe1ddc.svg";
export { ForwardRef as ReactComponent };